const KeyMirror = require("keymirror");

module.exports = KeyMirror({
    ADD_PROMOCODE_BEGIN: true,
    ADD_PROMOCODE_SUCCESS: true,
    ADD_PROMOCODE_FAILURE: true,
    DELETE_PROMOCODE_BEGIN: true,
    DELETE_PROMOCODE_SUCCESS: true,
    DELETE_PROMOCODE_FAILURE: true,
    FETCH_PROMOCODES_BEGIN: true,
    FETCH_PROMOCODES_SUCCESS: true,
    FETCH_PROMOCODES_FAILURE: true,
    FETCH_SINGLE_PROMOCODE_BEGIN: true,
    FETCH_SINGLE_PROMOCODE_SUCCESS: true,
    FETCH_SINGLE_PROMOCODE_FAILURE: true,
    UPDATE_PROMOCODE_BEGIN: true,
    UPDATE_PROMOCODE_SUCCESS: true,
    UPDATE_PROMOCODE_FAILURE: true
});



// WEBPACK FOOTER //
// ./src/action-types/promocodes.js